import Types from "./Types";
/* eslint-disable camelcase */

/************************************************
Get Reports
*************************************************/

const getReports = query => {
  return { type: Types.GET_REPORTS, query };
};

const getReportsSuccess = reports => ({
  type: Types.GET_REPORTS_SUCCESS,
  reports
});

const getReportsFailure = error => ({
  type: Types.GET_REPORTS_FAILURE,
  error
});

/************************************************
Export reports
*************************************************/

const exportReports = (name, link, param) => {
  return { type: Types.EXPORT_REPORTS, name, link, param };
};

const exportReportsSuccess = report => ({
  type: Types.EXPORT_REPORTS_SUCCESS,
  report
});

const exportReportsFailure = error => ({
  type: Types.EXPORT_REPORTS_FAILURE,
  error
});

// Clear Reports
const clearReports = () => ({ type: Types.CLEAR_REPORTS });

/************************************************
Get Sales Data
*************************************************/

const getSales = query => {
  return { type: Types.GET_SALES, query };
};

const getSalesSuccess = sales => ({
  type: Types.GET_SALES_SUCCESS,
  sales
});

const getSalesFailure = error => ({
  type: Types.GET_SALES_FAILURE,
  error
});

/************************************************
Get SalesItem details Data
*************************************************/

const getSalesItemDetails = query => {
  return { type: Types.GET_SALES_ITEM_DETAILS, query };
};

const getSalesItemDetailsSuccess = salesItem => ({
  type: Types.GET_SALES_ITEM_DETAILS_SUCCESS,
  salesItem
});

const getSalesItemDetailsFailure = error => ({
  type: Types.GET_SALES_ITEM_DETAILS_FAILURE,
  error
});

/************************************************
GET SALES STATUS
*************************************************/

const getSalesStatus = () => {
  return {
    type: Types.GET_SALES_STATUS
  };
};

const getSalesStatusSuccess = (salesStatus) => {
  return {
    type: Types.GET_SALES_STATUS_SUCCESS,
    salesStatus
  };
};

const getSalesStatusFailure = error => ({
  type: Types.GET_SALES_STATUS_FAILURE,
  error
});

export {
  getReports,
  getReportsSuccess,
  getReportsFailure,
  exportReports,
  exportReportsSuccess,
  exportReportsFailure,
  clearReports,
  getSales,
  getSalesSuccess,
  getSalesFailure,
  getSalesItemDetails,
  getSalesItemDetailsSuccess,
  getSalesItemDetailsFailure,
  getSalesStatus,
  getSalesStatusSuccess,
  getSalesStatusFailure
};



// WEBPACK FOOTER //
// ./src/actions/ReportsActions.js